export default __webpack_public_path__ + "static/media/african-proficient-capital-image.a0e963d0.jpg";